module.exports = __webpack_public_path__ + "img/combate-incendios.55bb4a73.jpg";